import { dataProps, logProps } from './properties'

export const setAssetMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}  

export const setAssetMasterData = (state, payload) => {
    state.props = payload.response
    if(payload.copy) {
        state.props.id = 0
    }

} 


export const resetAssetMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/assetMaster/mutations.js